import angular from 'angular';

export default (function () {
  const originalModule = angular.module;

  // Wrap angular.module to add component registration methods
  angular.module = function (...args) {
    const mod = originalModule.apply(this, args);

    if (!mod.registerComponents) {
      mod.registerComponents = function (components, type) {
        Object.entries(components).forEach(([varName, definition]) => {
          switch (type) {
            case 'controller':
              this.registerController(varName, definition);
              break;
            case 'service':
              this.registerService(varName, definition);
              break;
            case 'directive':
              this.registerDirective(varName, definition);
              break;
            case 'config':
              this.registerConfig(definition);
              break;
            case 'constant':
              this.registerConstant(varName, definition);
              break;
            case 'filter':
              this.registerFilter(varName, definition);
              break;
            case 'factory':
              this.registerFactory(varName, definition);
              break;
            case 'run':
              this.registerRun(definition);
              break;
            default:
              throw new Error(`Unknown component type: ${type}`);
          }
        });
      };

      // Controller Registration
      mod.registerController = function (name, definition) {
        if (Array.isArray(definition)) {
          // Definition is already [deps..., fn]
          this.controller(name, definition);
        } else if (
          typeof definition === 'object' &&
          definition !== null &&
          Object.values(definition).length === 1
        ) {
          // Object form: { controllerName: [deps..., fn] }
          const controllerName = Object.keys(definition)[0];
          const controllerDef = definition[controllerName];
          this.controller(controllerName, controllerDef);
        } else {
          throw new Error(`Invalid controller definition: ${name}`);
        }
      };

      // Service Registration
      mod.registerService = function (name, definition) {
        this.service(name, definition);
      };

      // Directive Registration
      mod.registerDirective = function (name, definition) {
        this.directive(name, definition);
      };

      // Config Registration
      mod.registerConfig = function (definition) {
        this.config(definition);
      };

      // Constant Registration
      mod.registerConstant = function (name, definition) {
        if (
          typeof definition === 'object' &&
          definition !== null &&
          !Array.isArray(definition)
        ) {
          const keys = Object.keys(definition);
          if (keys.length === 1) {
            const constantName = keys[0];
            const constantValue = definition[constantName];
            this.constant(constantName, constantValue);
          } else {
            this.constant(name, definition); // fallback
          }
        } else {
          throw new Error(`Invalid constant format: ${name}`);
        }
      };

      // Filter Registration
      mod.registerFilter = function (name, definition) {
        if (typeof definition === 'function') {
          this.filter(name, definition); // Register the filter directly
        } else {
          throw new Error(`Invalid filter definition: ${name}`);
        }
      };

      // Factory Registration
      mod.registerFactory = function (name, definition) {
        if (typeof definition === 'function') {
          // Definition is already a factory function
          this.factory(name, definition);
        } else if (typeof definition === 'object' && definition !== null) {
          // Definition is an object with a factory function
          const keys = Object.keys(definition);
          if (keys.length === 1) {
            const factoryName = keys[0];
            const factoryFn = definition[factoryName];
            this.factory(factoryName, factoryFn);
          } else {
            throw new Error(`Invalid factory definition: ${name}`);
          }
        } else {
          throw new Error(`Invalid factory format: ${name}`);
        }
      };

      // Run Registration
      mod.registerRun = function (definition) {
        this.run(definition);
      };
    }

    return mod;
  };
})();
